export const apiEndPoints = {
  biddingItems: '/bidding_items',
  updateBiddingPrices: '/bidding_items/update_bidding_prices',
  paymentConditions: '/payment_conditions',
  billingCompany: '/miscellaneous/billing_company',
}

export default apiEndPoints
